// Lazy loader for Mapbox GL - only loads when needed
// This prevents the 2.3MB mapbox-gl library from being bundled into the main application.js

let mapboxPromise = null

export async function loadMapboxGL() {
  if (typeof window.mapboxgl !== 'undefined') {
    return window.mapboxgl
  }

  if (mapboxPromise) {
    return mapboxPromise
  }

  mapboxPromise = new Promise((resolve, reject) => {
    // Load CSS
    if (!document.querySelector('link[href*="mapbox-gl.css"]')) {
      const css = document.createElement('link')
      css.rel = 'stylesheet'
      css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.9.4/mapbox-gl.css'
      document.head.appendChild(css)
    }

    // Load JS
    const script = document.createElement('script')
    script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.9.4/mapbox-gl.js'
    script.onload = () => resolve(window.mapboxgl)
    script.onerror = () => reject(new Error('Failed to load Mapbox GL JS'))
    document.body.appendChild(script)
  })

  return mapboxPromise
}

export async function loadMapboxDraw() {
  // Ensure Mapbox GL is loaded first
  await loadMapboxGL()

  if (typeof window.MapboxDraw !== 'undefined') {
    return window.MapboxDraw
  }

  return new Promise((resolve, reject) => {
    // Load CSS
    if (!document.querySelector('link[href*="mapbox-gl-draw.css"]')) {
      const css = document.createElement('link')
      css.rel = 'stylesheet'
      css.href = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.4.3/mapbox-gl-draw.css'
      document.head.appendChild(css)
    }

    // Load JS
    const script = document.createElement('script')
    script.src = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.4.3/mapbox-gl-draw.js'
    script.onload = () => resolve(window.MapboxDraw)
    script.onerror = () => reject(new Error('Failed to load Mapbox Draw'))
    document.body.appendChild(script)
  })
}
